define(function (require) {
    var WebAgentUtils = require('web-agent-utils/WebAgentUtils');
    var ViewController = require('web-agent-framework/ViewController');

    ViewController.plugin({
        sanitizeText: function(text) {
            return WebAgentUtils.sanitizeText.call(this, text);
        }
    });
});
